import React from 'react';

import RadioButtonList from '../../../../../components/radio-button-list';
import { EXTENDED_RANGES, ExtendedRange } from '../../../range';
import './styles.scss';

interface AccountEquityHeaderProps {
  rangeSelected: ExtendedRange;
  setRangeSelected: React.Dispatch<React.SetStateAction<ExtendedRange>>;
}

const AccountEquityHeader: React.FC<AccountEquityHeaderProps> = ({
  rangeSelected,
  setRangeSelected,
}) => {
  const onChangeRange = (range: string) => {
    setRangeSelected(range as ExtendedRange);
  };

  return (
    <div className="header">
      <h1>Account equity</h1>
      <RadioButtonList
        options={EXTENDED_RANGES}
        defaultValue={rangeSelected}
        dividerBefore={['MTD']}
        onChange={onChangeRange}
      />
    </div>
  );
};

export default AccountEquityHeader;
